// Lightweight wrapper around Google Analytics (gtag) for custom events.
// Safe no-op if gtag isn't loaded (e.g., during SSR or ad-blockers).
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
};

export const trackProjectActClick = (source) => {
  trackEvent('project_act_cta_click', {
    event_category: 'project_act',
    event_label: source,
    source,
  });
};
